import Annexure1a from "../../components/pages/CBSE-Disclosure-Pages/Annexure1a";

export default Annexure1a;
